module.exports = __webpack_public_path__ + "static/media/yonatan.6d4c658a.png";